export default "__VITE_ASSET__Buh2CNgk__"